import { useTranslation } from "react-i18next";
import { LabelPrintingWorkstationPanel } from "@/components/labels/LabelPrintingWorkstationPanel";

export default function LabelPrinting() {
  const { t } = useTranslation("settings");

  return (
    <div className="min-h-screen bg-background pb-24 mx-auto w-full max-w-4xl">
      <div className="px-6 pt-8 pb-6">
        <h1 className="text-2xl font-bold text-foreground">{t("nav.labelPrinting")}</h1>
        <p className="text-muted-foreground">Configure the label printer attached to this workstation.</p>
      </div>
      <div className="px-6">
        <LabelPrintingWorkstationPanel />
      </div>
    </div>
  );
}
